import React, { Component } from 'react'
import { MessageComponentProps, FirebaseMessage } from '@deal/chat-firebase'
import { Link } from 'react-router-dom'
import { Avatar } from '@deal/components'
import styles from './styles.css'
import { ChatLeadComponent, MessageRichCardType } from '#src/generated/graphql'

export default class ProductCuration extends Component<MessageComponentProps, {}> {
  public static handlesMessage(message: FirebaseMessage) {
    return (
      (message.parts[0].body.type === 'new-lead-rich-seq-expert-joined' ||
        message.parts[0].body.richCardType === MessageRichCardType.ONBOARDING_EXPERT_JOINED) &&
      message.parts[0].body.queryVariables &&
      message.parts[0].body.queryVariables.leadId
    )
  }

  public render() {
    const { leadId } = this.props.message.parts[0].body.queryVariables
    return (
      <ChatLeadComponent variables={{ leadId }}>
        {({ data }) => {
          if (data && data.lead) {
            const {
              latestRequest,
              expert: { firstName, lastName, expertProfile, expertAttributes }
            } = data.lead
            const name = [firstName, lastName].filter(Boolean).join(' ')
            const isPlaceholderExpert = expertAttributes && expertAttributes.placeholderExpert

            // No point in rendering this card if you don't have a request and category
            if (!latestRequest || !data.lead.category) return null

            const category = data.lead.category

            return (
              <div className={styles.container}>
                {expertProfile &&
                  expertProfile.profilePhoto && (
                    <Link to={`/experts/${data.lead.expert.vanityId}`}>
                      <Avatar size={64} name={name} src={expertProfile.profilePhoto.url} />
                    </Link>
                  )}
                <div className={styles.message}>
                  {isPlaceholderExpert ? (
                    <span className={styles.name}>{name}</span>
                  ) : (
                    <Link to={`/experts/${data.lead.expert.vanityId}`} className={styles.name}>
                      {name}
                    </Link>
                  )}{' '}
                  joined the conversation
                </div>
                <div className={styles.category}>
                  {category.singularDisplayName.toLowerCase()} expert
                </div>
              </div>
            )
          } else {
            return null
          }
        }}
      </ChatLeadComponent>
    )
  }
}
